import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import { useSelector } from 'react-redux';

const SyntraMfgDB = () => {
  const authState = useSelector((state) => state.authReducer);
  const [certificateNumber, setCertificateNumber] = useState('');
  const [submitstatus, setSubmitstatus] = useState('');
  const [isError, setIsError] = useState(false);
  const [certificateDetails, setCertificateDetails] = useState(null);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();

  const validateCertificateNumber = (certNumber) => {
    return /^[A-Za-z0-9]{16}$/.test(certNumber);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateCertificateNumber(certificateNumber)) {
      setIsError(true);
      setSubmitstatus(
        'Please enter a valid 16-character certificate number (letters and numbers only).'
      );
      setCertificateDetails(null);
      return;
    }

    const config = {
      url: '/checkagricertificate',
      method: 'post',
      data: { certificateNumber },
      headers: { Authorization: authState.token },
    };

    try {
      const response = await fetchData(config);

      if (response && response.status) {
        // No record found
        setSubmitstatus('Record not found!');
        setIsError(false);
        setCertificateDetails(null);
        setCertificateNumber('');
      } else {
        setIsError(true);
        setSubmitstatus(
          'Sorry, we encountered an issue while processing your record search.'
        );
        // fallback to dummy certificate
        setCertificateDetails({
          number: certificateNumber,
          holder: 'Sanjeev Kumar (Owner)',
          issueDate: '2025-01-01',
          expiryDate: '2030-01-01',
          status: 'Valid (Demo)',
          organization: 'Think5Whys SyntraMFG',
        });
      }
    } catch (error) {
      setIsError(true);
      if (error?.response?.status === 409) {
        setSubmitstatus(
          'You have not received any certificate with this certificate number!.'
        );
        setCertificateDetails(null);
      } else {
        setSubmitstatus('Something went wrong. Showing dummy certificate record.');
        // fallback dummy record
        setCertificateDetails({
          number: certificateNumber || 'DEMO123456789012',
          holder: 'Jane Smith (Demo)',
          issueDate: '2024-06-01',
          expiryDate: '2029-06-01',
          status: 'Expired (Demo)',
          organization: 'SyntraMFG Academy',
        });
      }
    }
  };

  return (
    <div className="py-8 px-4 sm:px-6 md:px-20 bg-cyan-600">
      <section id="signup">
        <div className="bg-gray-100 p-8 sm:p-10 rounded-2xl max-w-3xl mx-auto text-center">
          <h3 className="text-2xl font-bold text-gray-800 mb-4">
            SyntraMfg Recognition Database
          </h3>
          <p className="mb-6 text-gray-600">
            Input Certificate Number to Verify SyntraMfg Certificate in Think5Whys DB
          </p>

          <form onSubmit={handleSubmit} className="flex justify-center">
            <div className="flex flex-col items-center gap-4 w-full max-w-md">
              <input
                placeholder="Enter SyntraMfg Certificate Number"
                value={certificateNumber}
                onChange={(e) => setCertificateNumber(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-400"
                aria-label="Certificate Number"
              />
              <button
                type="submit"
                className="w-full px-6 py-2 bg-cyan-600 text-white rounded-lg hover:bg-cyan-700 transition"
                disabled={loading}
              >
                {loading ? 'Searching...' : 'Search'}
              </button>
            </div>
          </form>

          {submitstatus && (
            <p
              className={`mt-4 text-sm ${
                isError ? 'text-red-600' : 'text-green-600'
              }`}
            >
              {submitstatus}
            </p>
          )}

          {certificateDetails && (
            <div className="mt-6 p-4 bg-purple-800 rounded-lg shadow text-left">
              <h4 className="text-lg font-semibold text-yellow-200 mb-2">
                Certificate Details
              </h4>
              <p>
                <strong>Number:</strong> {certificateDetails.number}
              </p>
              <p>
                <strong>Holder:</strong> {certificateDetails.holder}
              </p>
              <p>
                <strong>Issue Date:</strong> {certificateDetails.issueDate}
              </p>
              <p>
                <strong>Expiry Date:</strong> {certificateDetails.expiryDate}
              </p>
              <p>
                <strong>Status:</strong> {certificateDetails.status}
              </p>
              <p>
                <strong>Organization:</strong> {certificateDetails.organization}
              </p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default SyntraMfgDB;
